
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-appliance-installation-services/[[...slug]]",
      function () {
        return require("private-next-pages/home-appliance-installation-services/[[...slug]].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-appliance-installation-services/[[...slug]]"])
      });
    }
  